{
  "replaceMessage": "Plasați fișierul pentru a înlocui"
}
